export var OptimizelyDeployEnv = /*#__PURE__*/function (OptimizelyDeployEnv) {
  OptimizelyDeployEnv["PRODUCTION"] = "prod";
  OptimizelyDeployEnv["DEVELOPMENT"] = "dev";
  return OptimizelyDeployEnv;
}({});
export var OptimizelyAttributes = /*#__PURE__*/function (OptimizelyAttributes) {
  OptimizelyAttributes["IS_MOBILE"] = "FUNNEL_isMobile";
  OptimizelyAttributes["COUNTRY"] = "FUNNEL_country";
  OptimizelyAttributes["REGION"] = "FUNNEL_region";
  OptimizelyAttributes["OS"] = "FUNNEL_OS";
  OptimizelyAttributes["CURRENCY"] = "FUNNEL_currency";
  OptimizelyAttributes["BROWSER"] = "FUNNEL_browser";
  OptimizelyAttributes["BROWSER_VERSION"] = "FUNNEL_browserVersion";
  OptimizelyAttributes["HAS_PAYMENT_METHOD"] = "FUNNEL_hasPaymentMethod";
  OptimizelyAttributes["PRODUCT_ID"] = "FUNNEL_productId";
  OptimizelyAttributes["DEPLOY_ENV"] = "FUNNEL_deployEnv";
  OptimizelyAttributes["CHECKOUT_ACTION"] = "FUNNEL_checkoutAction";
  OptimizelyAttributes["PRODUCT_FAMILY"] = "FUNNEL_productFamily";
  OptimizelyAttributes["REFERRER"] = "FUNNEL_referrer";
  return OptimizelyAttributes;
}({});
export var DEFAULT_OPTIMIZELY_TIMEOUT = 500;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/OptimizelyUtils/constants.js
// module id = 1358
// module chunks = 11